const Images = {
  description: require('./description.svg'),
  bg1: require('./bg1.svg'),
  bg1MB: require('./bg1MB.svg'),
  bg2: require('./bg2.svg'),
  bg3: require('./bg3.svg'),
  bg3t: require('./bg3t.svg'),
  bg2MB: require('./bg2MB.svg'),
  bg3MB: require('./bg3MB.svg'),
  bg2MBt: require('./bg2MBt.svg'),
  bg3MBt: require('./bg3MBt.svg'),
  youtubeFrameBorder: require('./youtube-frame-border.png'),
  chrome: require('./chrome.svg'),
  safari: require('./safari.svg'),
  // yoshimoto
  intro: require('./yoshimoto/intro.jpg'),
  introMobile: require('./yoshimoto/intro-mobile.jpg'),
  logoYoshimoto: require('./yoshimoto/logo.svg'),
  icSmileFace: require('./yoshimoto/smile-face.png'),
  icInfinity: require('./yoshimoto/infinity.png'),
  icCopy: require('./yoshimoto/copy.svg'),
  icError: require('./yoshimoto/error.png'),
  icArrowUp: require('./yoshimoto/arrow-up.svg'),
  phoneMockup: require('./yoshimoto/phone-mockup.png'),
  phoneTwitter: require('./yoshimoto/phone-twitter.png'),
  appStore: require('./yoshimoto/app-store.png'),
  googlePlay: require('./yoshimoto/google-play.png'),
  googlePlayComingSoon: require('./yoshimoto/google-play-coming-soon.png'),
  flags: {
    en: require('./yoshimoto/en.png'),
    jp: require('./yoshimoto/ja.png'),
  }
}
export default Images